export { default } from "./ProjectLocationsV2Mspa";
